// Formato mínimo de un email válido: algo@dominio.ext, SIN espacios — hace falta donde un email
// crudo de `usuarios.email` puede venir incompleto (ej. solo el dominio de una empresa, sin
// usuario: "samsung.com" — caso hipotético que motivó este fix, Radar Comercial, caso Samsung
// 2026-09-27) o con basura de carga (espacio/salto de línea al final, caso REAL medido en la DB:
// "loreto.novoa@omd.com " — CONSORCIO, contacto de agencia). Fuente ÚNICA (10.27) — cualquier
// chequeo de "¿este email sirve para escribirle a alguien?" pasa por acá.
//
// A propósito NO se hace `.trim()` antes de testear: el criterio es "sin espacios" tal cual está
// guardado en la DB — trimear primero ocultaría justo el caso real de arriba (espacio final),
// tratándolo como válido cuando el dato sigue roto para escribirle a esa persona.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const esEmailValido = (email) => typeof email === "string" && EMAIL_REGEX.test(email);
